import { Vendor, vendors } from './vendor.enum'

export function initDefaultTcfVendorsConsentsMap() {
  const vendorsConsentStates: Map<Vendor, boolean> = new Map()
  vendors.forEach((vendorId) => {
    vendorsConsentStates.set(vendorId, false)
  })
  return vendorsConsentStates
}
